import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { apiSendMessageToRD } from "Root/api/apiProfile";
import DrawerComponent from "Root/profile/components/common/DrawerComponent";
import H2Font from "Root/profile/components/common/H2Font";
import LargeFont from "Root/profile/components/common/LargeFont";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import toastService from "Root/profile/toastService";
import TextArea from "Root/quiz/elements/textAreaInput/textArea";
import styles from "./styles.module.scss";
const TargetResultsHelp = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [values, setValues] = useState({
        message: "",
    });
    const toggleDrawer = (value) => () => {
        setOpenDrawer(value);
    };
    const onChange = (value, name) => {
        setValues({
            ...values,
            [name]: value,
        });
    };
    const submit = () => {
        toggleDrawer(false)();
        apiSendMessageToRD({ msg: values.message, subject: 'Target Customer Inquiry' });
        toastService.successMessage("Message sent! A member of our RD team will reach out within 2-3 business days.");
        setValues({
            message: "",
        });
    };
    const isValid = () => {
        return Object.values(values).every((item) => !!item);
    };
    const isMobile = useScreenWidth() < 968;
    return (_jsxs("div", { className: styles.help, children: [_jsx(H2Font, { children: "Still need help?" }), _jsx(LargeFont, { children: "Submit your questions below and a member of our RD team will reach out within a 2-3 business days." }), _jsx(RoundedGainfulButton, { extraClassName: styles.btn, label: "Get Help", onClick: toggleDrawer(true) }), _jsxs(DrawerComponent, { extraClassName: styles.help_drawer, open: openDrawer, toggleDrawer: toggleDrawer, anchor: isMobile ? "bottom" : "right", crossButton: true, children: [_jsxs("div", { className: styles.help_drawer_wrapper, children: [_jsx(H2Font, { children: "Still need help?" }), _jsx(LargeFont, { children: "Submit your questions below and a member of our RD team will get back to you shortly." })] }), _jsxs("div", { className: styles.help_form, children: [_jsxs("div", { className: styles.textarea, children: [_jsx("span", { className: "input-form-control__label", children: "Message" }), _jsx(TextArea, { rows: 10, extraClassName: styles.textarea_input, value: values.message, setValue: (e) => onChange(e, "message"), maxLength: 600 })] }), _jsx(RoundedGainfulButton, { disabled: !isValid(), label: "Submit", onClick: submit })] })] })] }));
};
export default TargetResultsHelp;
